<template>
    <span>
        <img v-show="showDefault" :src="defaultUrl" alt="Company Logo">
        <img v-show="!showDefault" :src="logoUrl" @load="onLoaded();" style="background: white;" alt="Logo">
    </span>
</template>

<script>
export default {
    name:"BaseLogo",
    props: ["domain"],  
    data() {
        return {
            loaded: false,
            defaultUrl: '../../static/assets/img/a14.jpg',
        };
    },
    computed: {
        logoUrl() {
            return "http://logo.clearbit.com/" + this.domain;
        },
        showDefault() {
            return !(this.domain && this.loaded); 
        }
    },
    watch: {
        domain() {
            this.loaded = false;
        }
    },
    methods: {
        onLoaded() {
            this.loaded = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CompanyLogo.vue